module.exports = __webpack_public_path__ + "img/excel.52faddc8.svg";